<div class="scope-tabs">
  <div class="scope-tabs-strip">
    <button class="scope-tab" *ngFor="let s of scopeNames"
            [class.scope-tab-active]="s === activeScope"
            (click)="setActive(s)">
      <span class="scope-tab-name">{{s}}</span>
      <button mat-icon-button class="scope-tab-action"
              (click)="promptRename(s, $event)" [disabled]="readOnly"
              i18n-aria-label="@@Rename scope" aria-label="Rename scope">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button class="scope-tab-action"
              (click)="confirmDelete(s, $event)" [disabled]="readOnly"
              i18n-aria-label="@@Delete scope" aria-label="Delete scope">
        <mat-icon>delete</mat-icon>
      </button>
    </button>

    <button mat-stroked-button color="primary" class="scope-tab-add"
            (click)="promptAdd()" [disabled]="readOnly">
      <mat-icon>add</mat-icon>
      <span i18n="@@Add scope">Add scope</span>
    </button>
  </div>

  <div class="scope-tabs-empty" *ngIf="scopeNames.length === 0">
    <span i18n="@@No scopes defined yet. Add one to get started.">No scopes defined yet. Add one to get started.</span>
  </div>
</div>

